import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { MediaFileService } from './media-file.service';
import { Icon } from '../upas/icon.model';

@Injectable({ providedIn: 'root' })
export class IconsService {
  path: string = '/api';
  constructor(
    private apiService: ApiService,
    private mediaFilesService: MediaFileService,  
  ) { }

  getIcons(partnerId: number) {
    return this.apiService.get<Icon[]>(`${this.path}/airlines/${partnerId}/icons`);
  }

  createIcon(partnerId: number, file: File) {
    const data = new FormData();
    data.append('file', file, this.mediaFilesService.sanitizeFileName(file.name));
    return this.apiService.postForm(`${this.path}/airlines/${partnerId}/icons`, data);
  }

  updateIcon(id: number, file: File) {
    const data = new FormData();
    data.append('file', file, this.mediaFilesService.sanitizeFileName(file.name));
    return this.apiService.putForm(`${this.path}/icons/${id}`, data);
  }

  deleteIcon(id: number) {
    return this.apiService.delete(`${this.path}/icons/${id}`);
  }
}
